// Built-in Imports
import Typewriter from "typewriter-effect";
import { GiCloudDownload } from "react-icons/gi";
import { FormattedMessage } from "react-intl";

// Internal Imports
import { Wrapper, Hi } from "./hello-text.styles";
import { useAppContext } from "../../layout/layout";
import { CurrentActivity, LinkButton } from "../index";

const HelloText = () => {
  const { lang } = useAppContext();

  const skills =
    lang === "en"
      ? ["MERN Stack Developer...!", "Front-End Developer...!"]
      : ["MERN Stack Entwickler...!", "Front-End Entwickler...!"];
  return (
    <Wrapper>
      <h4>
        <FormattedMessage
          id="qInfo.part1"
          values={{
            hi: <Hi className="hi">{lang === "en" ? "Hi" : "Hallo"}</Hi>,
          }}
          defaultMessage="Hi, this is"
        />
      </h4>
      <h3>
        <FormattedMessage id="qInfo.part2" defaultMessage="Shafiq Salehi," />{" "}
      </h3>
      <h4 className="">
        <FormattedMessage
          id="qInfo.part3"
          defaultMessage="and I am a highly professional"
        />
      </h4>
      <h3>
        <Typewriter
          options={{
            strings: skills,
            autoStart: true,
            delay: 2,
            pauseFor: 2000,
            loop: true,
          }}
        />
      </h3>
      <LinkButton herf="./assets/files/RESUME.pdf">
        <FormattedMessage id="cv" defaultMessage="resume" />
      </LinkButton>
      <CurrentActivity />
    </Wrapper>
  );
};
export default HelloText;
